import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Icon from '~/core/scripts/components/Icon';

class ExpandButton extends PureComponent {
  static propTypes = {
    isExpanded: PropTypes.bool,
    onToggle: PropTypes.func
  }

  static defaultProps = {
    isExpanded: false,
    onToggle: () => {}
  }

  render() {
    const { isExpanded } = this.props;
    const label = isExpanded ? 'Kompaktansicht' : 'Alle Parteien, alle Stimmen einblenden';
    const iconType = isExpanded ? 'up' : 'down';

    return (
      <div
        className="rankinglist__expand"
        onClick={this.props.onClick}
      >
        <Icon type={iconType}/> {label}
      </div>
    );
  }
}

export default ExpandButton;
